import { MDText } from 'i18n-react';
import { startsWith } from 'lodash';

import { BagIcon, TagIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import {
	triggerActiveBidsSidebarClickedEvent,
	triggerCancelledPurchaseSidebarClickedEvent,
	triggerCompletePurchaseSidebarClickedEvent,
	triggerDidntWinBidsSidebarClickedEvent,
	triggerUnderOfferBidsSidebarClickedEvent,
} from 'Services/analytics/events';
import { AccountCategory, AccountSlugs } from 'Types/account';
import ROUTES from 'Utilities/routes';

import LocalTexts from './AccountSidebar.texts';
import type { AccountSidebarItems, AccountSidebarSections, AccountSidebarTitles } from './AccountSidebar.types';

const LocalT = new MDText(LocalTexts);

export const ACCOUNT_SIDEBAR_SECTIONS: AccountSidebarSections = {
	bids: AccountCategory.BIDS,
	purchases: AccountCategory.PURCHASES,
};

export const ACCOUNT_SIDEBAR_TITLES: AccountSidebarTitles = {
	bids: {
		icon: TagIcon,
		title: LocalT.translate('accountSidebar.titles.bidsAndOffers'),
	},
	purchases: {
		icon: BagIcon,
		title: LocalT.translate('accountSidebar.titles.purchases'),
	},
};

export const ACCOUNT_SIDEBAR_ITEMS: AccountSidebarItems = {
	bids: [
		{
			as: ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.ACTIVE),
			cypressId: cypressIds.accountSidebar.bidsAndOffers.active,
			href: ROUTES.ACCOUNT.href,
			isActive: ({ asPath }) => startsWith(asPath, ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.ACTIVE)),
			onClick: () => triggerActiveBidsSidebarClickedEvent(),
			slug: AccountSlugs.ACTIVE,
			text: LocalT.translate('accountSidebar.links.bidsAndOffers.active'),
		},
		{
			as: ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.UNDER_OFFER),
			cypressId: cypressIds.accountSidebar.bidsAndOffers.underOffer,
			href: ROUTES.ACCOUNT.href,
			isActive: ({ asPath }) => startsWith(asPath, ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.UNDER_OFFER)),
			onClick: () => triggerUnderOfferBidsSidebarClickedEvent(),
			slug: AccountSlugs.UNDER_OFFER,
			text: LocalT.translate('accountSidebar.links.bidsAndOffers.underOffer'),
		},
		{
			as: ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.DIDNT_WIN),
			cypressId: cypressIds.accountSidebar.bidsAndOffers.didntWin,
			href: ROUTES.ACCOUNT.href,
			isActive: ({ asPath }) => startsWith(asPath, ROUTES.ACCOUNT.as(AccountCategory.BIDS, AccountSlugs.DIDNT_WIN)),
			onClick: () => triggerDidntWinBidsSidebarClickedEvent(),
			slug: AccountSlugs.DIDNT_WIN,
			text: LocalT.translate('accountSidebar.links.bidsAndOffers.didntWin'),
		},
	],
	purchases: [
		{
			as: ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.COMPLETE),
			cypressId: cypressIds.accountSidebar.purchases.complete,
			href: ROUTES.ACCOUNT.href,
			isActive: ({ asPath }) => startsWith(asPath, ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.COMPLETE)),
			onClick: () => triggerCompletePurchaseSidebarClickedEvent(),
			slug: AccountSlugs.COMPLETE,
			text: LocalT.translate('accountSidebar.links.purchases.complete'),
		},
		{
			as: ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.CANCELLED),
			cypressId: cypressIds.accountSidebar.purchases.cancelled,
			href: ROUTES.ACCOUNT.href,
			isActive: ({ asPath }) =>
				startsWith(asPath, ROUTES.ACCOUNT.as(AccountCategory.PURCHASES, AccountSlugs.CANCELLED)),
			onClick: () => triggerCancelledPurchaseSidebarClickedEvent(),
			slug: AccountSlugs.CANCELLED,
			text: LocalT.translate('accountSidebar.links.purchases.cancelled'),
		},
	],
};
